import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { GatewayService } from 'src/app/gateway.service';
import { switchMap, debounceTime, tap, finalize } from 'rxjs/operators';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentTabController } from 'src/app/tab-controller';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { UploadServiceService } from 'src/app/services/upload-service.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';

@Component({
	selector: 'app-createcampana',
	templateUrl: './createcampana.component.html',
	styleUrls: ['./createcampana.component.scss']
})
export class CreatecampanaComponent implements OnInit {

	// previewColumns = ['ID', 'NOMBRECLIENTE', 'TELEFONO', 'CODCLIENTE', 'SEGMENTO', 'RANGOMORA', 'ACCION'];
	previewColumns = ['ID', 'NOMBRECLIENTE', 'TELEFONO', 'ACCION'];
	previewColumns1 = ['NO', 'TIPOLOGIA', 'SUBTIPOLOGIA', 'ACCION1', 'ACCION2'];
	previewColumns2 = ['NO', 'REGLA', 'ACCION1', 'ACCION2'];
	dataSource = [];
	canalesdig = [];
	reglasnegocio = [];
	dataSource1 = new MatTableDataSource<any>(this.canalesdig);
	dataSource2 = new MatTableDataSource<any>(this.reglasnegocio);
	cantidadtotalarchivo: number = 0;
	isLoadingEje: boolean = false;
	filteredOptions: Observable<string[]>;
	check = false;
	file; valor; script; file2; valor2;

	resultsLength: number = 0;
	pageSize = 5;
	filterLista = null;
	@ViewChild('listaPaginator') listaPaginator: MatPaginator;

	table = [];
	campanas = [];

	//maxDate = new Date();
	minDate = new Date();
	maxDate = new Date();

	estados: any = [
		{ ID: 1, DESCRIPCION: 'Activo' },
		{ ID: 2, DESCRIPCION: 'Inactivo' },
	];

	medios: any = [
		// { ID: 1, NOMBRE: 'SMS' },
		{ ID: 2, NOMBRE: 'TMK' },
		{ ID: 3, NOMBRE: 'Whatsapp' },
		{ ID: 4, NOMBRE: 'Correo electrónico' },
	];

	tipclis: any = [
		{ ID: 1, NOMBRE: 'Móvil' },
		{ ID: 2, NOMBRE: 'Fijo' }
	];

	tipcargas: any = [
		{ NOMBRE: 'Leads', ID: 1 },
		{ NOMBRE: 'Existentes', ID: 2 },
		{ NOMBRE: 'De Baja', ID: 3 }
	]

	tipos: any = [
		{ nombre: 'Postventa', value: 0 },
		{ nombre: 'Backoffice', value: 1 },
		{ nombre: 'N/A', value: 2 }
	]

	public isLoadingAgente: boolean = false;
	public filteredOptionsAgente: Observable<string[]>;
	public agentesarray: any = [];
	public agenteduplicada: boolean = false;
	public fechainicio = new Date();

	grupoVal = new FormGroup({
		eje: new FormControl('', Validators.required),
		nombre: new FormControl('', [Validators.compose([
			Validators.required, Validators.minLength(2), Validators.maxLength(60)
			// ,Validators.pattern("[a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
		])]),
		estado: new FormControl('', Validators.required),
		medio: new FormControl('', Validators.required),
		script: new FormControl(''),
		scripturl: new FormControl(''),
		// fechaini: new FormControl('', Validators.required),
		// fechafin: new FormControl('', Validators.required),
		fechaini: new FormControl(new Date(`${this.fechainicio.getFullYear()}-${this.dosDig(this.fechainicio.getMonth() + 1)}-${this.dosDig(this.fechainicio.getDate())}T00:00:00`)),
		fechafin: new FormControl(new Date('2028-12-31T00:00:00')),

		contacto: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
		conversion: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
		efectividad: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
		llamadas: new FormControl(0, [Validators.min(0), Validators.required]),
		llamadascep: new FormControl(0, [Validators.min(0), Validators.required]),
		tmo: new FormControl(0, [Validators.min(0), Validators.required]),
		// tipoalta: new FormControl(0, Validators.required),
		// tipcli: new FormControl(0, Validators.required),
		// tipcarga: new FormControl(0, Validators.required),
		tipoalta: new FormControl(0),
		tipcli: new FormControl(0),
		tipcarga: new FormControl(0),
		AUTORIZACION_DUPLICADO: new FormControl(''),
	});

	grupoVal1 = new FormGroup({
		agente: new FormControl('', Validators.required),
		porcontacto: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
		porefectivo: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
		porconvertido: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
		llamadas: new FormControl(0, [Validators.min(0), Validators.required]),
		llamadascep: new FormControl(0, [Validators.min(0), Validators.required]),
		tmoa: new FormControl(0, [Validators.min(1), Validators.required]),
	});

	grupoVal2 = new FormGroup({
		mensajec1: new FormControl('', Validators.required),
		mensajec2: new FormControl('', Validators.required),
		check1: new FormControl(false),
		check2: new FormControl(false)
	});

	grupoVal3 = new FormGroup({
		tipologia: new FormControl('', Validators.required),
		subtipologia: new FormControl(''),
		accion: new FormControl('', Validators.required)
	});

	grupoVal4 = new FormGroup({
		regla: new FormControl('', Validators.required),
		accion: new FormControl('', Validators.required)
	});

	tipologias = [];
	subtipologias = [];
	acciones = [];
	acciones_ = [];
	reglas = [];

	constructor(
		private gateway: GatewayService,
		private snackbar: MatSnackBar,
		public dialogRef: MatDialogRef<CreatecampanaComponent>,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) private data,
		public localSave: LocalSaveService,
		public tabController: ComponentTabController,
		private spinner: NgxSpinnerService,
		private uploadService: UploadServiceService

	) { }

	ngOnInit() {

		// VERIFICAR SI SOLO ES LECTURA
		this.localSave.set('solo_ver', null);
		if (this.data && this.data.title && this.data.title == 'Ver ') {
			this.localSave.set('solo_ver', true);
		}

		this.localSave.set('campana', -1);
		this.tabController.index = 0;
		this.grupoVal.controls['scripturl'].disable();

		////////////////////////////////-------------EJE--------------\\\\\\\\\\\\\\\\\\\\\\\\\\\\
		this.loadEje();
		this.loadAgentesTable();
		this.getCampanas();
		this.grupoVal
			.get('eje')
			.valueChanges
			.pipe(
				debounceTime(300),
				tap(() => this.isLoadingEje = true),
				switchMap(value =>
					this.gateway.get('geteje', { NUM_PAGINA: 0, FILTRO: value, NUM_ELEMENTOS: 5, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA })
						.then((result: any) => {
							this.filteredOptions = result.rows;
							this.isLoadingEje = false;
						}
						).catch(function (e) {
						})
				)
			)
			.subscribe(eje => {
			}
			);

		this.grupoVal1
			.get('agente')
			.valueChanges
			.pipe(
				debounceTime(300),
				tap(() => this.isLoadingAgente = true),
				switchMap(value =>
					this.gateway.get('getagenteagente', { NUM_PAGINA: 0, FILTRO: value, NUM_ELEMENTOS: 5, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA })
						.then((result: any) => {
							this.filteredOptionsAgente = result.rows;
							this.isLoadingAgente = false;
						}
						).catch(function (e) {
						})
				)
			)
			.subscribe(campana => {
			}
			);

		// WHATSAPP
		this.gateway.get('getmsjwhatsapp', {
			IDCAMPANA: this.localSave.get('campana')
		}).then((data: any) => {
			if (data.rows.length) {
				// console.log('>>>>>>>  getmsjwhatsapp');
				// console.log(data.rows)
				let datos = data.rows[0];
				this.grupoVal2.controls.mensajec1.setValue(datos.mensaje1);
				this.grupoVal2.controls.mensajec2.setValue(datos.mensaje2);
				this.grupoVal2.controls.check1.setValue(datos.habilitar1);
				this.grupoVal2.controls.check2.setValue(datos.habilitar2);
			}
		});

		this.gateway.get('get_subtipologias', { IDTIPOLOGIA: 2, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA })
			.then((result: any) => {
				// console.log(result.rows);
				this.acciones = result.rows;
				this.acciones_ = result.rows.filter(element => element.idtipologia != 5);
			});

		this.gateway.get('gettipo', {})
			.then((result: any) => {
				// console.log(result.rows);
				this.tipologias = result;
			});

		this.gateway.get('getreglaoport', {})
			.then((result: any) => {
				// console.log(result.rows);
				this.reglas = result;
			});
		////////////////////////////////-------------EJE--------------\\\\\\\\\\\\\\\\\\\\\\\\\\\\

	}

	dosDig(num) {
		return num < 10 ? '0' + num : num;
	}

	// GESTOR DE OPORTUNIDADES
	addGestorOportunidad() {
		let nuevo = {
			regla: this.grupoVal4.controls.regla.value,
			accion: this.grupoVal4.controls.accion.value
		};

		// console.log(nuevo)

		if (this.reglasnegocio.find(element => {
			return (nuevo.regla.IDREGLA == element.regla.IDREGLA &&
				nuevo.accion.idtipologia == element.accion.idtipologia);
		})) {
			this.snackbar.open('Ya tiene asignada la nueva combinación', '', {
				duration: 3000,
			});
			return;
		} else {
			this.reglasnegocio.push(nuevo);
			this.dataSource2 = new MatTableDataSource<any>(this.reglasnegocio);

			this.grupoVal4.controls.regla.setValue(null);
			this.grupoVal4.controls.accion.setValue(null);
		}
	}

	deleteGestorOportunidad(indice) {
		this.reglasnegocio.splice(indice, 1);
		this.dataSource2 = new MatTableDataSource(this.reglasnegocio);
	}

	saveGestorOportunidad() {
		this.spinner.show();
		this.gateway.get('insertgestoroportunidad', {
			REGLASNEGOCIO: this.reglasnegocio,
			IDCAMPANA: this.localSave.get('campana')
		}).then((data: any) => {
			this.tabController.index = 9;
			this.snackbar.open('Datos de reglas de negocio guardados correctamente.', 'Cerrar', { duration: 3000, });
			this.spinner.hide();
		});
	}

	// CANALES DIGITALES

	addCanalDigital() {
		let nuevo = {
			tipologia: this.grupoVal3.controls.tipologia.value,
			subtipologia: this.grupoVal3.controls.subtipologia.value,
			accion: this.grupoVal3.controls.accion.value
		};

		// console.log(nuevo)

		if (this.canalesdig.find(element => {
			return (nuevo.tipologia.IDTIPOLOGIA == element.tipologia.IDTIPOLOGIA &&
				(nuevo.subtipologia != null ? (nuevo.subtipologia.IDTIPOLOGIA == element.subtipologia.IDTIPOLOGIA) : true) &&
				nuevo.accion.idtipologia == element.accion.idtipologia);
		})) {
			this.snackbar.open('Ya tiene asignada la nueva combinación', '', {
				duration: 3000,
			});
			return;
		} else {
			this.canalesdig.push(nuevo);
			this.dataSource1 = new MatTableDataSource<any>(this.canalesdig);

			this.grupoVal3.controls.tipologia.setValue(null);
			this.grupoVal3.controls.subtipologia.setValue(null);
			this.grupoVal3.controls.subtipologia.setValidators(null);
			this.grupoVal3.controls.accion.setValue(null);
			this.grupoVal3.controls.tipologia.updateValueAndValidity();
			this.grupoVal3.controls.subtipologia.updateValueAndValidity();
			this.grupoVal3.controls.accion.updateValueAndValidity();
		}
	}

	deleteCanalDigital(indice) {
		this.canalesdig.splice(indice, 1);
		this.dataSource1 = new MatTableDataSource(this.canalesdig);
	}

	saveCanalDigital() {
		this.spinner.show();
		this.gateway.get('insertcanalesdig', {
			CANALESDIG: this.canalesdig,
			IDCAMPANA: this.localSave.get('campana')
		}).then((data: any) => {
			this.tabController.index = 8;
			this.snackbar.open('Datos de canales digitales guardados correctamente.', 'Cerrar', { duration: 3000, });
			this.spinner.hide();
		});
	}

	changeTipologia() {
		this.grupoVal3.controls.subtipologia.setValue(null);
		this.gateway.get('getsubtipo', { IDTIPOLOGIA: this.grupoVal3.controls.tipologia.value.IDTIPOLOGIA })
			.then((result: any) => {
				// console.log(result.rows);
				this.subtipologias = result;
				if (this.subtipologias.length) {
					// this.grupoVal3.controls.subtipologia.setValidators([Validators.required]);
					this.grupoVal3.controls.subtipologia.setValidators(null);
				} else {
					this.grupoVal3.controls.subtipologia.setValidators(null);
				}
				this.grupoVal3.controls.subtipologia.updateValueAndValidity();
			});
	}

	saveWhatsapp() {
		this.spinner.show();
		this.gateway.get('upsertwhatsapp', {
			IDCAMPANA: this.localSave.get('campana'),
			MENSAJE1: this.grupoVal2.controls.mensajec1.value,
			MENSAJE2: this.grupoVal2.controls.mensajec2.value,
			HABILITAR1: this.grupoVal2.controls.check1.value,
			HABILITAR2: this.grupoVal2.controls.check2.value
		}).then((data: any) => {
			this.tabController.index = this.localSave.get('usuarioPGV').TIPO == 1 ? 7 : 6;
			this.snackbar.open('Datos de whatsapp guardados correctamente.', 'Cerrar', { duration: 3000, });
			this.spinner.hide();
		});
	}

	guardado = 0;
	idcampana = 0;

	// tabChanged(event) {

	// 	if ((event.index == 8 && this.localSave.get('usuarioPGV').TIPO == 1 && this.grupoVal.controls.tipcarga.value == 1) ||
	// 		(event.index == 6 && this.localSave.get('usuarioPGV').TIPO == 1 && this.grupoVal.controls.tipcarga.value != 1) ||
	// 		(event.index == 6 && this.localSave.get('usuarioPGV').TIPO == 2)) {
	// 		this.spinner.show();
	// 		this.listaPaginator.firstPage();
	// 		/////////////////////////////////// PREVLIST
	// 		this.gateway.get('prevlista', { IDCAMPANA: this.localSave.get('campana'), FILTRO: null, PAGINA: 0 })
	// 			.then((result: any) => {
	// 				this.dataSource = result.CLIENTES;
	// 				this.cantidadtotalarchivo = result.CANTIDAD;
	// 				this.resultsLength = result.CANTIDAD;
	// 				// console.log(result);
	// 				this.spinner.hide();
	// 			}
	// 			).catch(function (e) {
	// 				this.spinner.hide();
	// 			})
	// 		/////////////////////////////////// PREVLIST
	// 	}
	// }

	tabChanged(event) {
		alert(event.index);
		if (event.index == 4) {
			this.spinner.show();
			this.listaPaginator.firstPage();
			/////////////////////////////////// PREVLIST
			this.gateway.get('prevlista', { IDCAMPANA: this.data.idcampana, FILTRO: null, PAGINA: 0 })
				.then((result: any) => {
					this.dataSource = result.CLIENTES;
					this.cantidadtotalarchivo = result.CANTIDAD;
					this.resultsLength = result.CANTIDAD;
					// console.log(result);
					this.spinner.hide();
				}
				).catch(function (e) {
					this.spinner.hide();
				})
			/////////////////////////////////// PREVLIST
		}
	}

	save() {

		this.spinner.show();
		// console.log(this.script);
		// console.log(this.grupoVal.controls.eje);
		let tipo = 'createcampana';
		if (this.guardado == 1) {
			tipo = 'modifyCampana';
			this.idcampana = this.localSave.get('campana');
		}
		// console.log(tipo)
		// console.log(this.idcampana)
		if (this.grupoVal.controls.eje.value.ideje) {
			this.grupoVal1.controls.porcontacto.setValue(this.grupoVal.controls.contacto.value);
			this.grupoVal1.controls.porefectivo.setValue(this.grupoVal.controls.conversion.value);
			this.grupoVal1.controls.porconvertido.setValue(this.grupoVal.controls.efectividad.value);
			this.grupoVal1.controls.tmoa.setValue(this.grupoVal.controls.tmo.value);
			this.grupoVal1.controls.llamadas.setValue(this.grupoVal.controls.llamadas.value);
			this.grupoVal1.controls.llamadascep.setValue(this.grupoVal.controls.llamadascep.value);

			if (typeof (this.script) == "undefined") {
				let CAMPANA = {
					IDEJE: this.grupoVal.controls.eje.value.ideje,
					NOMBRE: this.grupoVal.controls.nombre.value,
					ESTADO: this.grupoVal.controls.estado.value,
					MEDIO: this.grupoVal.controls.medio.value,
					VIGENCIAINICIAL: this.grupoVal.controls.fechaini.value,
					VIGENCIAFINAL: this.grupoVal.controls.fechafin.value,
					SCRIPT: this.grupoVal.controls.script.value,
					SCRIPTURL: '',
					IDPAIS: this.data.idpais,
					CONTACTO: String(this.grupoVal.controls.contacto.value).length == 0 ? 0 : this.grupoVal.controls.contacto.value,
					CONVERSION: String(this.grupoVal.controls.conversion.value).length == 0 ? 0 : this.grupoVal.controls.conversion.value,
					EFECTIVIDAD: String(this.grupoVal.controls.efectividad.value).length == 0 ? 0 : this.grupoVal.controls.efectividad.value,
					IDCAMPANA: this.idcampana,
					TMO: String(this.grupoVal.controls.tmo.value).length == 0 ? 0 : this.grupoVal.controls.tmo.value,
					TIPOALTA: this.grupoVal.controls.tipoalta.value,
					LLAMADAS: this.grupoVal.controls.llamadas.value,
					LLAMADASCEP: this.grupoVal.controls.llamadascep.value,
					TIPOCLIENTE: this.grupoVal.controls.tipcli.value,
					TIPOCARGA: this.localSave.get('usuarioPGV').TIPO == 1 ? this.grupoVal.controls.tipcarga.value : 1,
					IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU,
					AUTORIZACION_DUPLICADO: this.grupoVal.controls.AUTORIZACION_DUPLICADO.value
				}

				this.gateway.save(tipo, CAMPANA).then((result: any) => {
					// this.dialogRef.close();
					if (tipo == 'createcampana') {
						this.localSave.set('campana', result.rows[0].crear_campana);
						// console.log(this.localSave.get('campana'))
						// console.log(result.rows[0].crear_campana)
						this.gateway.get('setautorizacioncamp', {
							IDCAMPANA: result.rows[0].crear_campana,
							AUTORIZACION: this.localSave.get('usuarioPGV').AUTORIZACION_AUTO
						}).then();

					}
					this.tabController.index = 1;
					this.guardado = 1;
					this.spinner.hide();
					// Luego de guardar debo generar la lista si es externa
					// de ser interna entonces se genera hasta asignar los criterios
					if (this.grupoVal.controls.check.value) {
						this.cargarLista();
					}

				}).catch(function (e) { });
			}
			else {
				this.uploadService.uploadfile(this.script).then(
					data => {
						let CAMPANA = {
							IDEJE: this.grupoVal.controls.eje.value.ideje,
							NOMBRE: this.grupoVal.controls.nombre.value,
							ESTADO: this.grupoVal.controls.estado.value,
							MEDIO: this.grupoVal.controls.medio.value,
							VIGENCIAINICIAL: this.grupoVal.controls.fechaini.value,
							VIGENCIAFINAL: this.grupoVal.controls.fechafin.value,
							SCRIPT: this.grupoVal.controls.script.value,
							SCRIPTURL: data['Location'],
							IDPAIS: this.data.IDPAIS,
							CONTACTO: this.grupoVal.controls.contacto.value,
							CONVERSION: this.grupoVal.controls.conversion.value,
							EFECTIVIDAD: this.grupoVal.controls.efectividad.value,
							IDCAMPANA: this.idcampana,
							TMO: this.grupoVal.controls.tmo.value,
							TIPOALTA: this.grupoVal.controls.tipoalta.value,
							LLAMADAS: this.grupoVal.controls.llamadas.value,
							LLAMADASCEP: this.grupoVal.controls.llamadascep.value,
							TIPOCLIENTE: this.grupoVal.controls.tipcli.value,
							TIPOCARGA: this.localSave.get('usuarioPGV').TIPO == 1 ? this.grupoVal.controls.tipcarga.value : 1,
							IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU,
							AUTORIZACION_DUPLICADO: this.grupoVal.controls.AUTORIZACION_DUPLICADO.value
						}

						this.gateway.save(tipo, CAMPANA).then((result: any) => {
							// this.dialogRef.close();
							if (tipo == 'createcampana') {
								this.localSave.set('campana', result.rows[0].crear_campana);
								// console.log(this.localSave.get('campana'))
								// console.log(result.rows[0].crear_campana)
								this.gateway.get('setautorizacioncamp', {
									IDCAMPANA: result.rows[0].crear_campana,
									AUTORIZACION: this.localSave.get('usuarioPGV').AUTORIZACION_AUTO
								}).then();
							}
							this.tabController.index = 1;
							this.guardado = 1;
							this.spinner.hide();
							// Luego de guardar debo generar la lista si es externa
							// de ser interna entonces se genera hasta asignar los criterios
							if (this.grupoVal.controls.check.value) {
								this.cargarLista();
							}
						}
						).catch(function (e) {
						});
					}
				);
			}
		} else {
			this.spinner.hide();
			this.snackbar.open('Eje invalido.', 'Cerrar', { duration: 3000, });
			this.grupoVal.patchValue({
				eje: ''
			})

		}

	}

	loadEje() {
		this.gateway.get('geteje', { NUM_PAGINA: 0, FILTRO: null, NUM_ELEMENTOS: 5, IDPAIS: 0, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result: any) => {
			// console.log(result);
			this.filteredOptions = result.rows;
		}
		).catch(function (e) {
		});
	}

	displayFn(eje?: any): string | undefined {
		if (eje) { return eje.nombre }
	}

	onNoClick() {
		this.localSave.delete('campana');
		this.dialogRef.close();
	}

	getError(type) {
		if (type == 1) {
			if (this.grupoVal.controls.eje.hasError('required')) {
				return 'Debes seleccionar un Eje';
			}
		}
		else if (type == 2) {
			if (this.grupoVal.controls.nombre.hasError('required')) {
				return 'Debes ingresar un Nombre';
			}
		}
		else if (type == 3) {
			if (this.grupoVal.controls.estado.hasError('required')) {
				return 'Debes seleccionar una Estado';
			}
		}
		else if (type == 4) {
			if (this.grupoVal.controls.medio.hasError('required')) {
				return 'Debes seleccionar un Medio';
			}
		}
		else if (type == 5) {
			if (this.grupoVal.controls.scripturl.hasError('required')) {
				return 'Debes ingresar un Script';
			}
		}
		else if (type == 6) {
			if (this.grupoVal.controls.fechaini.hasError('required')) {
				return 'Debes seleccionar una Fecha Inicial Válida';
			}
		}
		else if (type == 7) {
			if (this.grupoVal.controls.fechafin.hasError('required')) {
				return 'Debes seleccionar una Fecha Final Válida';
			}
		}
		else if (type == 8) {
			return 'Debes ingresar un porcentaje entre 0 y 100';
		}
		else if (type == 9) {
			return 'Debes ingresar un un valor numérico';
		}
		else if (type == 10) {
			if (this.grupoVal1.controls.agente.hasError('required')) {
				return 'Debes seleccionar un agente';
			}
		}
		else if (type == 11) {
			if (this.grupoVal1.controls.porcontacto.hasError('required')) {
				return 'Debes ingresar un porcentaje contacto';
			} else if (this.grupoVal1.controls.porcontacto.hasError('min') || this.grupoVal1.controls.porcontacto.hasError('max')) {
				return 'Debes ingresar un porcentaje entre 0 y 100';
			}
		}
		else if (type == 12) {
			if (this.grupoVal1.controls.porefectivo.hasError('required')) {
				return 'Debes ingresar un porcentaje efectividad';
			} else if (this.grupoVal1.controls.porefectivo.hasError('min') || this.grupoVal1.controls.porefectivo.hasError('max')) {
				return 'Debes ingresar un porcentaje entre 0 y 100';
			}
		}
		else if (type == 13) {
			if (this.grupoVal1.controls.porconvertido.hasError('required')) {
				return 'Debes ingresar un porcentaje conversión';
			} else if (this.grupoVal1.controls.porconvertido.hasError('min') || this.grupoVal1.controls.porconvertido.hasError('max')) {
				return 'Debes ingresar un porcentaje entre 0 y 100';
			}
		}
		else if (type == 14) {
			if (this.grupoVal1.controls.tmoa.hasError('required')) {
				return 'Debes ingresar un TMO en segundos';
			} else if (this.grupoVal1.controls.tmoa.hasError('min') || this.grupoVal1.controls.porconvertido.hasError('max')) {
				return 'Debes ingresar un TMO mayor de 1 segundo';
			}
		}
		else if (type == 15) {
			if (this.grupoVal.controls.tipoalta.hasError('required')) {
				return 'Debes seleccionar Tipo alta';
			}
		}
	}

	openInput() {
		let hayClientes = true;
		try {
			hayClientes = (this.dataSource ? (this.dataSource.length > 0) : false);
		} catch (error) {
			hayClientes = false;
		}

		if (hayClientes) {
			const resultado = window.confirm('Recuerda que debes cargar un archivo .xlsx, con el mismo formato de columnas, tomando como referencia el primer archivo de clientes cargado.');
			if (resultado === true) {
				// window.alert('Okay, si estas seguro.');
				document.getElementById("fileInput").click();
			}
		} else {
			// var resultado = window.confirm('Recuerda guardar el formato de este archivo .xlsx, para futuras cargas de clientes cargado.');
			// if (resultado === true) {
			document.getElementById("fileInput").click();
			// }
		}
	}

	ObtenerArchivoCarga(event) {
		this.file = event.target.files[0];
		this.valor = this.file.name;
		if (typeof (this.file != "undefined")) {
			this.cargarLista();
		}
	}

	CargarScript(event) {
		this.script = event.target.files[0];
		if (this.script) {
			// console.log('----this.script.type---')
			// console.log(this.script)
			// console.log('----//this.script.type---')
			// if (this.script.type.toLowerCase() == 'application/pdf') {
			//console.log(this.script);
			this.grupoVal.controls['scripturl'].setValue(this.script.name)
			// } else {
			// 	this.script = undefined;
			// 	this.grupoVal.controls['scripturl'].setValue('')
			// 	this.snackbar.open('Solo se permiten archivos PDF.', 'Cerrar', { duration: 3000, });
			// }
		}
	}

	cargarLista() {
		this.spinner.show();
		const reader: FileReader = new FileReader();
		reader.onload = (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
			/* grab first sheet */
			const wsname: string = wb.SheetNames[0];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];
			/* save data */
			const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
			(<HTMLInputElement>document.getElementById('fileInput')).value = null;

			this.loadlistxls(dataexcel);
			// this.dialogRef.close({dataexcel:dataexcel,pais:this.PAIS,type:1});
		};
		reader.readAsBinaryString(this.file);

	}

	smsprogreso = "";
	async loadlistxls(data) {
		let keys = data.splice(0, 1)[0];
		let dataConvert: any = this.convertirArreglo(data, keys);
		if (dataConvert) {
			this.smsprogreso = "[FASE 1 de 2] El proceso a comenzado...";
		} else {
			return this.spinner.hide();
		}

		function sendLista(cantidad, gatew, idcampana, localspinner, localsnack, this2) {
			const that = this2;
			let auxarr = [];
			auxarr = dataConvert.slice(cantidad, cantidad + 100);
			// console.log('==========');
			// console.log(cantidad);
			// console.log(auxarr);
			// console.log('======//====');

			let encabezado = false;
			try {
				encabezado = cantidad == 0 && (this.dataSource ? (this.dataSource.length == 0) : true);
			} catch (error) {
				encabezado = true;
			}

			gatew.save('listaexistente', { CLIENTES: '', KEYS: keys, ENCABEZADO: encabezado, ARR_OBJ: auxarr, IDCAMPANA: idcampana }).then(
				res => {
					if ((cantidad + 100) < dataConvert.length) {
						this2.smsprogreso = "[FASE 2 de 2]  Se han insertado " + (cantidad + 100) + "  Clientes...";
						sendLista(cantidad + 100, gatew, idcampana, localspinner, localsnack, this2)
					} else {

						/////////////////////////////////// PREVLIST
						// gatew.get('prevlista', { IDCAMPANA: idcampana })
						// 	.then((result: any) => {
						// 		// console.log(result);
						// 		that.dataSource = result.CLIENTES;
						// 		that.cantidadtotalarchivo = result.CANTIDAD;
						// 	}
						// 	).catch(function (e) {
						// 	})
						gatew.get('prevlista', { IDCAMPANA: idcampana, FILTRO: null, PAGINA: 0 })
							.then((result: any) => {
								that.dataSource = result.CLIENTES;
								that.cantidadtotalarchivo = result.CANTIDAD;
								that.resultsLength = result.CANTIDAD;
								this2.smsprogreso = "";
								localspinner.hide();
								localsnack.open(`Han sido cargados ${cantfin} clientes con éxito de ${cantini}.`, 'Cerrar', { duration: 6000, });
							}
							).catch(function (e) {
							})
						/////////////////////////////////// PREVLIST
					}
				},

				err => {
					localsnack.open('Los clientes no han sido cargados, intente nuevamente.', 'Cerrar', { duration: 3000, });
					localspinner.hide();
					// console.log(err);
				}
			);

		}

		// console.log('======dataexcel====');
		// console.log(dataConvert);
		// console.log('======//dataexcel====');
		let cantini = dataConvert.length;
		let _filtrarcli = this.localSave.get('usuarioPGV').AUTORIZACION_DUPLICADO ? (this.grupoVal.controls.AUTORIZACION_DUPLICADO.value ? false : true) : true;
		dataConvert = await this.filtrarClientes(0, dataConvert, _filtrarcli);
		let cantfin = dataConvert.length;
		if (cantfin == 0) {
			this.spinner.hide();
			this.snackbar.open('No hay clientes nuevos para esta campaña.', 'Cerrar', { duration: 3000, });
			this.smsprogreso = '';
			return;
		}

		// console.log('==filtrado dataexcel=');
		// console.log(keys)
		// console.log(dataConvert);
		// console.log('======//dataexcel====');
		sendLista(0, this.gateway, this.localSave.get('campana'), this.spinner, this.snackbar, this);
	}

	filtrarClientes(cantidad, dataClient = [], _filtrarcli = false) {
		// 1. Insertar los datos en una tabla temporal
		// 2. Corroborar que no hayan clientes duplicados y devolver clientes no repetidos
		// 3. seguir con el proceso sendLista

		return new Promise((resolve, reject) => {

			let auxarr = [];
			auxarr = dataClient.slice(cantidad, cantidad + 500);

			this.gateway.get('filtrarclicamp', {
				IDCAMPANA: this.localSave.get('campana'),
				USUARIO: this.localSave.get('usuarioPGV'),
				CLIENTES: auxarr,
				FILTRARCLI: false // _filtrarcli
			}).then(
				async (data: any) => {
					// if (data.rows.length > 0) {
					// 	resolve(data.rows);
					// } else {
					// 	this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
					// 	this.spinner.hide();
					// 	resolve([]);
					// }

					if ((cantidad + 500) < dataClient.length) {
						let arrcli = []
						this.smsprogreso = "[FASE 1 de 2]  Se han analizado " + (cantidad + 500) + "  Clientes...";
						arrcli = data.rows.concat(await this.filtrarClientes((cantidad + 500), dataClient, _filtrarcli));
						resolve(arrcli);
					} else {
						this.smsprogreso = "[FASE 1 de 2]  Se han analizado " + (dataClient.length) + "  Clientes...";
						resolve(data.rows);
					}

				}
			);
		});
	}

	convertirArreglo(data, keys) {
		// let keys = data.splice(0, 1)[0];
		// console.log(keys);
		let ret = [];
		try {
			data.forEach(element => {
				const obj: any = {};
				const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
				for (let index = 0; index < element.length; index++) {
					let aux: string = (keys[index] == null || keys[index] == undefined) ? '' : (keys[index] + '');
					let valor: string = (element[index] == null || element[index] == undefined) ? '' : (element[index] + '');
					aux = aux.toString().replace('"', '').trim();
					aux = aux.toString().replace(/'/g, "");
					aux = aux.toString().replace(/"/g, "");
					aux = aux.replace(/[\u0000-\u001F\u007F]/g, "")   // limpia caracteres invisibles
						 .replace(/\\(?![nrtu"\\])/g, "/");       // reemplaza \ que no forman un escape válido

					valor = valor.toString().replace('"', '').trim();
					valor = valor.toString().replace(/'/g, "");
					valor = valor.toString().replace(/"/g, "");
					valor = valor.replace(/[\u0000-\u001F\u007F]/g, "")   // limpia caracteres invisibles
						 .replace(/\\(?![nrtu"\\])/g, "/");      // reemplaza \ que no forman un escape válido

					if (index == 17 || index == 18) // Fecha_1(R), Fecha_2(S)
					{
						obj[aux] = regex.test(valor) ? valor : null;
					}
					else if (index == 19) // Monto (S)
					{
						valor = valor.replace(/[^0-9.]/g, '');
						// si tiene más de un punto, dejar solo el primero
						const parts = valor.split('.');
						if (parts.length > 2) {
							valor = parts.shift() + '.' + parts.join('');
						}
						obj[aux] = valor ? valor : null;
					} else {
						obj[aux] = valor;
					}
				}

				if (
					(this.verificarCampoNumerico(obj.CUENTA) || this.verificarCampoNumerico(obj.cuenta) || this.verificarCampoNumerico(obj.Cuenta)) &&
					this.verificarCampoNumerico(obj.TELEFONO) || this.verificarCampoNumerico(obj.telefono) || this.verificarCampoNumerico(obj.Telefono)
				) {

					obj._IDTELEFONOCAMPANA = obj.id || obj.ID || obj.Id;
					// obj.TELEFONO = obj.TELEFONO || obj.Telefono || obj.telefono;
					obj.TELEFONO = (obj.TELEFONO+'').replace(/\D/g, "");
					// obj.CUENTA = obj.CUENTA || obj.Cuenta || obj.cuenta;
					ret.push(obj);
				}
			});
			if (ret.length
				&& (ret[0].CUENTA || ret[0].cuenta || ret[0].Cuenta)
				&& (ret[0].TELEFONO || ret[0].telefono || ret[0].Telefono)) {
				return ret;
			} else {
				this.snackbar.open('Archivo no válido, La columna CUENTA es obligatoria.', 'Cerrar', { duration: 3000 });
				return null;
			}
		} catch (e) {
			this.spinner.hide();
			this.snackbar.open('Archivo no válido intente de nuevo.', 'Cerrar', { duration: 3000, });
			return null;
		}
	}

	verificarCampoNumerico(campo) {
		if (campo == null || campo == undefined || campo == '') {
			return false;
		} else if (typeof campo === 'number') {
			return true;
		} else if (typeof campo === 'string') {
			campo = campo.trim();
			campo = campo.replace(/\D/g, "");
			return /^[0-9]+$/.test(campo);
		} else {
			return false;
		}
	}

	openInput2() {
		document.getElementById("fileInput2").click();
	}

	ObtenerArchivoCarga2(event) {

		this.file2 = event.target.files[0];
		this.valor2 = this.file2.name;
	}

	// convertirArreglo(data) {
	// 	let keys = data.splice(0, 1)[0];
	// 	// console.log(keys);
	// 	let ret = [];
	// 	data.forEach(element => {
	// 		var obj: any = {};
	// 		for (let index = 0; index < element.length; index++) {
	// 			let aux: string = keys[index];
	// 			aux = aux.replace('"', '').trim();
	// 			obj[aux] = element[index];
	// 		}
	// 		ret.push(obj);
	// 	});
	// 	return ret;
	// }

	exportar() {
		this.spinner.show();
		this.gateway.get('exportarlistacount', { IDCAMPANA: this.localSave.get('campana') }).then(
			(data: any) => {
				if (data.rows[0].cantidad > 0) {
					this.prepararinformacion(this.localSave.get('campana'), data.rows[0].cantidad, 0, null);
				} else {
					this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
					this.spinner.hide();
				}
			}
		);
	}

	prepararinformacion(campana, count, index, data) {
		this.gateway.get('exportarlistalote', { IDCAMPANA: campana, LIMIT: 100, OFFSET: index }).then(
			(result: any) => {
				if (data) {
					data = data.concat(result.rows)
				} else {
					data = result.rows;
				}
				let control = index + 100;
				if (control <= count) {
					this.prepararinformacion(campana, count, control, data);
				} else {
					this.descargarexcel(data, campana);
				}
			}
		);
	}

	descargarexcel(ctr, campana) {
		const fileName = 'Campana' + campana + '-' + Date.now();
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ctr);
		XLSX.utils.book_append_sheet(wb, ws);

		const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
		saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
		this.spinner.hide();
	}

	openInputScript() {
		document.getElementById("fileInputScript").click();
	}

	public displayFnAgente(agente?: any): string | undefined {
		if (agente) { return agente.nombre }
	}

	public loadAgentesTable() {
		this.gateway.get('agentecampanalite', { IDCAMPANA: this.idcampana }).then((result: any) => {
			// console.log(result);
			this.agentesarray = result.rows;
		}
		).catch(function (e) {
		});
	}

	public loadAgentes() {
		this.gateway.get('getagenteagente', { NUM_PAGINA: 0, FILTRO: null, NUM_ELEMENTOS: 5, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result: any) => {
			// console.log(result);
			this.filteredOptionsAgente = result.rows;
		}
		).catch(function (e) {
		});
	}

	public agregaragente() {
		this.agenteduplicada = false;

		// if(this.grupoVal1.controls.agente.value.idagente){
		// 		let exist = this.agentesarray.map((e) => {
		// 		return e.idagente;
		// 	}).indexOf(this.grupoVal1.controls.agente.value.idagente);
		// 	if (exist == -1) {
		// 		this.agentesarray.push({ idagente: this.grupoVal1.controls.agente.value.idagente, contacto: this.grupoVal1.controls.porcontacto.value, efectividad: this.grupoVal1.controls.porefectivo.value, conversion: this.grupoVal1.controls.porconvertido.value, nombre: this.grupoVal1.controls.agente.value.nombre, apellido: this.grupoVal1.controls.agente.value.apellido, correo: this.grupoVal1.controls.agente.value.correo, tmo:this.grupoVal1.controls.tmoa.value, });
		// 		this.grupoVal1.controls.agente.setValue('');
		// 		this.grupoVal1.controls.agente.reset();
		// 		this.grupoVal1.controls.porcontacto.setValue(this.grupoVal.controls.contacto.value);
		// 		this.grupoVal1.controls.porefectivo.setValue(this.grupoVal.controls.conversion.value);
		// 		this.grupoVal1.controls.porconvertido.setValue(this.grupoVal.controls.efectividad.value);
		// 		this.grupoVal1.controls.tmoa.setValue(this.grupoVal.controls.tmo.value);
		// 	} else {
		// 		this.agenteduplicada = true;
		// 		this.snackbar.open('Agente ya se encuentra en la lista', 'CERRAR', { duration: 3000 });
		// 	}
		// }else{
		// 	this.grupoVal1.controls.agente.setValue('');
		// 	this.grupoVal1.controls.agente.reset();
		// 	this.snackbar.open('Debe seleccionar un agente válido.', 'CERRAR', { duration: 3000 });
		// }
		if (this.grupoVal1.controls.agente.value.idagente) {
			let exist = this.agentesarray.map((e) => {
				return e.idagente;
			}).indexOf(this.grupoVal1.controls.agente.value.idagente);

			if (exist == -1) {
				this.spinner.show();
				this.gateway.get('campanasagente', { IDAGENTE: this.grupoVal1.controls.agente.value.idagente }).then((result) => {
					let aux: any = result;
					this.table = aux.rows;
					if (this.table.length > 0) {
						this.table.forEach(element => {
							element.campana = this.campanas.find((mini) => {
								return mini.idcampana == element.idcampana;
							})
						});
						this.gateway.save('validatraslapecampana', { CAMPANAS: this.table, NUEVA: { campana: { idcampana: this.localSave.get('campana') } } }).then((result: any) => {
							// if (result.validacion == 0) {
							this.spinner.hide();
							this.agentesarray.push({ idagente: this.grupoVal1.controls.agente.value.idagente, contacto: this.grupoVal1.controls.porcontacto.value, efectividad: this.grupoVal1.controls.porefectivo.value, conversion: this.grupoVal1.controls.porconvertido.value, nombre: this.grupoVal1.controls.agente.value.nombre, apellido: this.grupoVal1.controls.agente.value.apellido, correo: this.grupoVal1.controls.agente.value.correo, tmo: this.grupoVal1.controls.tmoa.value, llamadas: this.grupoVal1.controls.llamadas.value, llamadascep: this.grupoVal1.controls.llamadascep.value });
							this.grupoVal1.controls.agente.setValue('');
							this.grupoVal1.controls.porcontacto.setValue(this.grupoVal.controls.contacto.value);
							this.grupoVal1.controls.porefectivo.setValue(this.grupoVal.controls.conversion.value);
							this.grupoVal1.controls.porconvertido.setValue(this.grupoVal.controls.efectividad.value);
							this.grupoVal1.controls.tmoa.setValue(this.grupoVal.controls.tmo.value);
							this.grupoVal1.controls.llamadas.setValue(this.grupoVal.controls.llamadas.value);
							this.grupoVal1.controls.llamadascep.setValue(this.grupoVal.controls.llamadascep.value);
							this.grupoVal1.controls.agente.reset();
							// } else {
							// 	this.spinner.hide();
							// 	this.snackbar.open('No puedes agregar al agente debido a traslape de horario con otras campañas.', 'Cerrar', {
							// 		duration: 5000,
							// 	});
							// }

						})
					} else {
						this.spinner.hide();
						this.agentesarray.push({ idagente: this.grupoVal1.controls.agente.value.idagente, contacto: this.grupoVal1.controls.porcontacto.value, efectividad: this.grupoVal1.controls.porefectivo.value, conversion: this.grupoVal1.controls.porconvertido.value, nombre: this.grupoVal1.controls.agente.value.nombre, apellido: this.grupoVal1.controls.agente.value.apellido, correo: this.grupoVal1.controls.agente.value.correo, tmo: this.grupoVal1.controls.tmoa.value, llamadas: this.grupoVal1.controls.llamadas.value, llamadascep: this.grupoVal1.controls.llamadascep.value });
						this.grupoVal1.controls.agente.setValue('');
						this.grupoVal1.controls.porcontacto.setValue(this.grupoVal.controls.contacto.value);
						this.grupoVal1.controls.porefectivo.setValue(this.grupoVal.controls.conversion.value);
						this.grupoVal1.controls.porconvertido.setValue(this.grupoVal.controls.efectividad.value);
						this.grupoVal1.controls.tmoa.setValue(this.grupoVal.controls.tmo.value);
						this.grupoVal1.controls.llamadas.setValue(this.grupoVal.controls.llamadas.value);
						this.grupoVal1.controls.llamadascpe.setValue(this.grupoVal.controls.llamadascpe.value);
						this.grupoVal1.controls.agente.reset();
					}

				}
				).catch(function (e) { });

			} else {
				this.agenteduplicada = true;
				this.snackbar.open('Agente ya se encuentra en la lista', 'CERRAR', { duration: 3000 });
			}
		} else {
			this.grupoVal1.controls.agente.setValue('');
			this.grupoVal1.controls.agente.reset();
			this.snackbar.open('Debe seleccionar un agente válido.', 'CERRAR', { duration: 3000 });
		}

	}

	public remove(index): void {
		this.agentesarray.splice(index, 1);
	}

	public saveAgentes() {
		this.spinner.show();
		this.gateway.get('asignaragente', { IDCAMPANA: this.localSave.get('campana'), LISTA: this.agentesarray }).then((result: any) => {
			this.spinner.hide();
			//   console.log(result);
			this.tabController.index = 5;
			this.grupoVal1.controls.agente.setValue('');
			this.grupoVal1.controls.agente.reset();
			// this.grupoVal1.controls.porcontacto.setValue(0);
			// this.grupoVal1.controls.porefectivo.setValue(0);
			// this.grupoVal1.controls.porconvertido.setValue(0);
			// this.grupoVal1.controls.tmoa.setValue(0);
			// this.grupoVal1.controls.tmoa.reset();
			// this.grupoVal1.controls.porcontacto.reset();
			// this.grupoVal1.controls.porefectivo.reset();
			// this.grupoVal1.controls.porconvertido.reset();
			// this.filteredOptionsAgente = result.rows;
			this.grupoVal1.controls.porcontacto.setValue(this.grupoVal.controls.contacto.value);
			this.grupoVal1.controls.porefectivo.setValue(this.grupoVal.controls.conversion.value);
			this.grupoVal1.controls.porconvertido.setValue(this.grupoVal.controls.efectividad.value);
			this.grupoVal1.controls.tmoa.setValue(this.grupoVal.controls.tmo.value);
			this.grupoVal1.controls.llamadas.setValue(this.grupoVal.controls.llamadas.value);
			this.grupoVal1.controls.llamadascpe.setValue(this.grupoVal.controls.llamadascpe.value);

		}
		).catch(function (e) {
		});
	}

	openInputDelete() {
		document.getElementById("fileInputDelete").click();
	}

	ObtenerArchivoDelete(event) {

		this.file = event.target.files[0];
		this.valor = this.file.name;
		if (typeof (this.file != "undefined")) {
			//this.cargarLista();
			this.cargarListaDelete();
		}
	}

	deleteLista() {
		//console.log(element)

		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '300px',
			data: { operacion: 'deletelistacampana', id: { IDCAMPANA: this.localSave.get('campana') } }
		});

		dialogRef.afterClosed().subscribe(() => {
			this.gateway.get('prevlista', { IDCAMPANA: this.localSave.get('campana'), FILTRO: null, PAGINA: 0 })
				.then((result: any) => {
					// console.log(result);
					this.dataSource = result.CLIENTES;
					this.cantidadtotalarchivo = result.CANTIDAD;
					this.resultsLength = result.CANTIDAD;
					this.spinner.hide();
				}
				).catch(function (e) {
				})
		});

	}

	cargarListaDelete() {
		this.spinner.show();
		const reader: FileReader = new FileReader();
		reader.onload = (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
			/* grab first sheet */
			const wsname: string = wb.SheetNames[0];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];
			/* save data */
			const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
			(<HTMLInputElement>document.getElementById('fileInputDelete')).value = null;

			this.loadlistxlsDelete(dataexcel);
			// this.dialogRef.close({dataexcel:dataexcel,pais:this.PAIS,type:1});
			//console.log(dataexcel);
			//this.spinner.hide();
		};
		reader.readAsBinaryString(this.file);

	}

	loadlistxlsDelete(data) {
		//console.log(data);
		let keys = data.splice(0, 1)[0];
		const dataConvert = this.convertirArreglo(data, keys);
		// console.log(dataConvert);
		if (!dataConvert) {
			return this.spinner.hide();
		}

		function sendLista(cantidad, gatew, idcampana, localspinner, localsnack, this2) {
			const that = this2;
			let auxarr = [];
			auxarr = dataConvert.slice(cantidad, cantidad + 100);
			gatew.save('desasignarlista', { CLIENTES: '', ARR_OBJ: auxarr, IDCAMPANA: idcampana }).then(
				res => {
					if ((cantidad + 100) < dataConvert.length) {
						sendLista(cantidad + 100, gatew, idcampana, localspinner, localsnack, this2)
					} else {
						localspinner.hide();
						localsnack.open('Clientes eliminados con éxito.', 'Cerrar', { duration: 3000, });
						/////////////////////////////////// PREVLIST
						gatew.get('prevlista', { IDCAMPANA: idcampana, FILTRO: null, PAGINA: 0 })
							.then((result: any) => {
								that.dataSource = result.CLIENTES;
								that.cantidadtotalarchivo = result.CANTIDAD;
								that.resultsLength = result.CANTIDAD;
								// console.log(result);
							}
							).catch(function (e) {
							})
						/////////////////////////////////// PREVLIST
					}
				},

				err => {
					localsnack.open('Los clientes no han sido eliminados, intente nuevamente.', 'Cerrar', { duration: 3000, });
					localspinner.hide();
					// console.log(err);
				}
			);

		}
		if (dataConvert.length > 0) {
			sendLista(0, this.gateway, this.localSave.get('campana'), this.spinner, this.snackbar, this);
		}
	}

	getCampanas() {
		this.gateway.get('listacampanas', { NUM_PAGINA: 0, FILTRO: null, NUM_ELEMENTOS: 5, IDPAIS: 5 }).then((result) => {
			let aux: any = result;
			this.campanas = aux.rows;
			//this.getLista();
		}
		).catch(function (e) {
		});
	}

	keyDownFunctionCampana(event) {
		if (event.keyCode == 13) {
			this.filtrarLista(0);
		} else if (event.keyCode == 8 && this.filterLista == '') {
			this.filtrarLista(0);
		}
	}

	filtrarLista(page) {
		this.spinner.show();
		if (page == 0) {
			this.listaPaginator.firstPage();
		}

		let fil = null;
		if (this.filterLista != "" && this.filterLista != null) {
			fil = '%' + this.filterLista + '%';
		}

		this.gateway.get('prevlista', { IDCAMPANA: this.localSave.get('campana'), FILTRO: fil, PAGINA: page })
			.then((result: any) => {
				this.dataSource = result.CLIENTES;
				this.cantidadtotalarchivo = result.CANTIDAD;
				this.resultsLength = result.CANTIDAD;
				this.spinner.hide();
				// console.log(result);
			}
			).catch(function (e) {
				this.spinner.hide();
			})
	}

	cambioElementosLista(event?: PageEvent) {
		this.filtrarLista(event.pageIndex);
	}

	deleteClienteLista(elemento) {
		//console.log(elemento)
		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '300px',
			data: { operacion: 'deleteclientelista', id: { IDCLIENTE: elemento.id, IDCAMPANA: this.localSave.get('campana') } }
		});

		dialogRef.afterClosed().subscribe((result) => {
			//console.log(result)
			this.filtrarLista(0);

		});
	}

}
